import { createI18n } from 'vue-i18n'
import es from '@/locales/es.json'
import en from '@/locales/en.json'

const i18n = createI18n({
  locale: 'en',
  fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE,
  legacy: false,
  messages: {
    es,
    en
  }
})

export default i18n

export const t = i18n.global.t
export const te = i18n.global.te
export const locale = i18n.global.locale
